import React from 'react';

const PrintManagerIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14.1667
                10.8416L14.1751
                10.8324"
                stroke="#595959"
                strokeLinecap="round"
                strokeLinejoin="round"/>
            <path
                d="M5.83333
                14.1667H14.1667M5
                8.33333V3C5
                2.72386
                5.22386
                2.5
                5.5
                2.5H14.5C14.7761
                2.5
                15
                2.72386
                15
                3V8.33333M17.5
                16.9V12.3333C17.5
                10.1242
                15.7091
                8.33333
                13.5
                8.33333H6.5C4.29086
                8.33333
                2.5
                10.1242
                2.5
                12.3333V16.9C2.5
                17.2314
                2.76863
                17.5
                3.1
                17.5H16.9C17.2314
                17.5
                17.5
                17.2314
                17.5
                16.9Z"
                stroke="#595959"
                strokeLinecap="round"
                strokeLinejoin="round"/>
        </svg>
    );
};

export default PrintManagerIcon;
